query dailyAnalyticsImpressionForCompany($input: GetDailyAnalyticsImpressionInput!) {
  dailyAnalyticsImpressionForCompany: dailyAnalyticsImpressionForCompany(input: $input) {
    impressions
    utmTrafficCounts {
      utmKey
      values {
        label
        count
      }
    }
  }
}
